// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vCNx4a0KdpkNMCV0lx4E{flex-direction:column;flex-grow:1;height:100%;display:flex}.xYotHYlKWv0fwwsLlT2i{flex-grow:1;display:flex;position:relative}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `vCNx4a0KdpkNMCV0lx4E`,
	"table": `xYotHYlKWv0fwwsLlT2i`
};
export default ___CSS_LOADER_EXPORT___;
